import React from "react";
import { useIntl } from "react-intl";
import * as Path from "../../Constants/GlobalConstant";

import LinkButton from "../../UI/Button/LinkButton";
import CornerBadge from "../../UI/Badge/CornerBadge";


function ProductCard(props) {
    const intl = useIntl();

    return (
        <div className="d-flex col-xs-12 col-md-6 col-xl-3">
            <div className="card">
                {props.badge && <CornerBadge label="NEW" />}
                <div>
                    <div className="text-center">
                        <img src={props.icon} alt={props.title} className="img-fluid" />
                    </div>
                </div>
                <div className="card-body">
                    <h5 className="card-title text-center mt-2">{props.title}</h5>
                    <div className="card-text">
                        {props.children}
                    </div>
                </div>
                <div className="card-footer">
                    <LinkButton
                        className="btn-block btn-orange"
                        to={props.link}
                        label={intl.messages.learnMore}
                    />
                </div>
            </div>
        </div>
    );
}

const ProductLine = (props) => {
    const intl = useIntl();

    return (
        <div className="row">
            <ProductCard
                title={intl.messages.productTitleCSharp}
                link={Path.CSHARP_PATH}
                icon="./images/sdk_for_csharp.svg"
            >
                {intl.messages.productTitleCSharpMsg}
            </ProductCard>

            <ProductCard
                title={intl.messages.productTitleWeb}
                link={Path.WEB_PATH}
                icon="./images/sdk_for_web.svg"
            >
                {intl.messages.productTitleWebMsg}
            </ProductCard>

            <ProductCard
                title={intl.messages.productTitleAndroid}
                link={Path.ANDROID_PATH}
                icon="./images/sdk_for_android.svg"
            >
                {intl.messages.productTitleAndroidMsg}
            </ProductCard>

            <ProductCard
                title={intl.messages.productTitleIos}
                link={Path.IOS_PATH}
                icon="./images/sdk_for_ios.svg"
            >
                {intl.messages.productTitleIosMsg}
            </ProductCard>           

            <ProductCard
                title={intl.messages.productTitleReactN}
                link={Path.REACTNATIVE_PATH}
                icon="./images/sdk_for_reactNative.svg"
            >
                {intl.messages.productTitleReactNMsg}
            </ProductCard>

            <ProductCard
                title={intl.messages.productTitleNode}
                link={Path.NODE_PATH}
                icon="./images/sdk_for_nodejs.svg"
            >
                {intl.messages.productTitleNodeMsg}
            </ProductCard>

            <ProductCard
                title={intl.messages.productTitleAPI}
                link={Path.APIS_PATH}
                icon="./images/rest_api.svg"
            >
                {intl.messages.productTitleAPIMsg}
            </ProductCard>
        </div>
    )
}

export default (ProductLine);